import { MakeCall } from 'ha/services/apiV2/createMakeCall';

const deleteQualificationRequirement =
  (makeCall: MakeCall) => (requirementId: string | number) =>
    makeCall('DELETE', `/api/v2/qualification/requirement/${requirementId}`);
export { deleteQualificationRequirement };
